export const JobLinks = (jobId = null) => {
  return [
    { id: 1, name: 'job_detail', url: `/superstack/jobs/${jobId}/` },
    { id: 2, name: 'job_matching_scores', url: `/superstack/jobs/${jobId}/scores/` },
  ];
};
